import { Badge, Space } from "antd";
import { Button } from "antd";
// import { PrinterOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { formatCommaNumber } from "../../../utils/util";
import { docLinkRender } from "../../../components/table/DocLink";
// import dayjs from 'dayjs';

export const accessColumn = ({ handleView, handleEdit }) => [
  {
    title: "id",
    key: "id",
    dataIndex: "id",
    align: "left",
    hidden: true,
  },
  {
    title: "Ingredients Code",
    dataIndex: "ig_code",
    key: "ig_code",
    width: "24%",
    sorter: (a, b) => (a?.ig_code || "").localeCompare(b?.ig_code || ""),
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดูข้อมูลวัตถุดิบ"),
  },
  {
    title: "Ingredients Name",
    dataIndex: "ig_name",
    key: "ig_name",
    width: "30%",
    sorter: (a, b) => (a?.ig_name || "").localeCompare(b?.ig_name || ""),
  },
  /* Yield (%) และ Multiply เป็นค่าที่ใช้คำนวณวัตถุดิบใน BOM
     แสดงเฉพาะตัวที่ตั้งค่าไว้ ตัวที่ยังไม่ได้ตั้งจะขึ้นขีด "-" ให้เห็นชัด */
  {
    title: "Yield (%)",
    dataIndex: "yield",
    key: "yield",
    width: "10%",
    align: "right",
    className: "pe-3",
    sorter: (a, b) => Number(a?.yield || 0) - Number(b?.yield || 0),
    render: (v) =>
      v === null || v === undefined || v === "" || Number(v) === 0
        ? "-"
        : `${formatCommaNumber(Number(v), 2, 0)} %`,
  },
  {
    title: "Multiply",
    dataIndex: "multiply",
    key: "multiply",
    width: "8%",
    align: "right",
    className: "pe-3",
    sorter: (a, b) => Number(a?.multiply || 0) - Number(b?.multiply || 0),
    render: (v) =>
      v === null || v === undefined || v === "" || Number(v) === 0
        ? "-"
        : formatCommaNumber(Number(v), 2, 0),
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    width: "8%",
    align: "center",
    render: (v) => v || "-",
  },
  {
    title: "สถานะ",
    dataIndex: "active_status",
    key: "active_status",
    width: "12%",
    sorter: (a, b) => (a?.active_status || "").localeCompare(b?.active_status || ""),
    render: (data) => (
      <div>
        {data === "เปิดการใช้งาน" ? (
          <Badge status="success" text="เปิดการใช้งาน" />
        ) : (
          <Badge status="error" text="ปิดการใช้การ" />
        )}
      </div>
    ),
  },
  {
    title: "Action",
    key: "operation",
    width: "12%",
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          onClick={() => handleView(record)}
        />
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />
      </Space>
    ),
  },
];

export const pkmaster = {
  pk_code : null,
  pk_name : null,
  pktype_id : null,
  fill_volume: 0,
  price : 0,
  unit : null,
  remark : null,
  dimension : null,
  weight_unit : 0,
}

export const volumelist = [
  { value:"100", label: "100 ml." },
  { value:"200", label: "200 ml." },
  { value:"500", label: "500 ml." },
  { value:"1000", label: "1,000 ml." },
];
